var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("CargoMsg.Cargo_UserSecurityPolicy"),
        width: "700px",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "el-form",
        { attrs: { "label-width": "130px", "label-position": "right" } },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("CargoMsg.Cargo_PolicySettings") } },
            [
              _c(
                "el-checkbox",
                {
                  attrs: { no: "policyEnabled" },
                  model: {
                    value: _vm.form.policyEnabled,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "policyEnabled", $$v)
                    },
                    expression: "form.policyEnabled"
                  }
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("CargoMsg.Cargo_EnableUserSecurityPolicy")) +
                      " "
                  )
                ]
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("CargoMsg.Cargo_PasswordLengthRange") } },
            [
              _c(
                "div",
                { staticStyle: { display: "flex" } },
                [
                  _c("auto-number-input", {
                    staticStyle: { width: "100px", "padding-right": "10px" },
                    attrs: { "enforce-min": true, min: 8, max: 20 },
                    on: { change: _vm.lengthChange },
                    model: {
                      value: _vm.form.minPasswordLength,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "minPasswordLength", $$v)
                      },
                      expression: "form.minPasswordLength"
                    }
                  }),
                  _vm._v(" - "),
                  _c("auto-number-input", {
                    staticStyle: {
                      width: "100px",
                      "padding-left": "10px",
                      "padding-right": "10px"
                    },
                    attrs: { "enforce-min": true, min: 8, max: 20 },
                    on: { change: _vm.lengthChange },
                    model: {
                      value: _vm.form.maxPasswordLength,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "maxPasswordLength", $$v)
                      },
                      expression: "form.maxPasswordLength"
                    }
                  }),
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("CargoMsg.Cargo_MaxLengthRange8to20")) +
                      " "
                  )
                ],
                1
              )
            ]
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("CargoMsg.Cargo_CompositionRule") } },
            [
              _c(
                "div",
                [
                  _c(
                    "el-checkbox",
                    {
                      attrs: { disabled: "", no: "requireDigit" },
                      model: {
                        value: _vm.form.requireDigit,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "requireDigit", $$v)
                        },
                        expression: "form.requireDigit"
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("CargoMsg.Cargo_RequireNumUpperLower")) +
                          " "
                      )
                    ]
                  )
                ],
                1
              ),
              _c(
                "div",
                [
                  _c(
                    "el-checkbox",
                    {
                      attrs: { no: "requireSpecialChar" },
                      model: {
                        value: _vm.form.requireSpecialChar,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "requireSpecialChar", $$v)
                        },
                        expression: "form.requireSpecialChar"
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t("CargoMsg.Cargo_MustIncludeSpecialChars")
                        ) + " "
                      )
                    ]
                  )
                ],
                1
              )
            ]
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("CargoMsg.Cargo_PasswordHistoryCheck") } },
            [
              _c(
                "div",
                { staticStyle: { display: "flex" } },
                [
                  _c("auto-number-input", {
                    staticStyle: { width: "100px", "padding-right": "10px" },
                    attrs: { "enforce-min": true, min: 0, max: 10 },
                    model: {
                      value: _vm.form.passwordRepeatCheck,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "passwordRepeatCheck", $$v)
                      },
                      expression: "form.passwordRepeatCheck"
                    }
                  }),
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("CargoMsg.Cargo_HistoryLength0to10")) +
                      " "
                  )
                ],
                1
              )
            ]
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("CargoMsg.Cargo_PasswordErrorLock") } },
            [
              _c(
                "div",
                { staticStyle: { display: "flex" } },
                [
                  _c("auto-number-input", {
                    staticStyle: { width: "100px", "padding-right": "10px" },
                    attrs: { "enforce-min": true, min: 0, max: 10 },
                    model: {
                      value: _vm.form.passwordErrorLock,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "passwordErrorLock", $$v)
                      },
                      expression: "form.passwordErrorLock"
                    }
                  }),
                  _vm._v(
                    " " + _vm._s(_vm.$t("CargoMsg.Cargo_LockLength0to10")) + " "
                  )
                ],
                1
              )
            ]
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("CargoMsg.Cargo_AdminApplication") } },
            [
              _c(
                "el-checkbox",
                {
                  attrs: { no: "applyToAdmin" },
                  model: {
                    value: _vm.form.applyToAdmin,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "applyToAdmin", $$v)
                    },
                    expression: "form.applyToAdmin"
                  }
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("CargoMsg.Cargo_AdminPwdFollowPolicy")) + " "
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.confirmHandler } },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Save")))]
          ),
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }